import { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const FeedbacksList = lazy(() => import('../../pages/feedbacks/FeedbacksListTable'));

function FeedbacksRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}`} component={FeedbacksList} />
        </Switch>
    );
}

export default FeedbacksRoute;
